import styled from 'styled-components';

export default styled.div`
    width: 100%;
    text-align: left;
    .error-title {
        font-family: Poppins !important;
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        text-align: left;
        margin-bottom: 24px;
    }
    .error-description {
        font-family: Poppins !important;
        font-size: 16px;
        font-weight: 300;
        line-height: 24px;
        text-align: left;
        margin-bottom: 24px;
    }
`;
